import { render } from "./WorkspaceLayout.vue?vue&type=template&id=02e18c70&ts=true"
import script from "./WorkspaceLayout.vue?vue&type=script&lang=ts"
export * from "./WorkspaceLayout.vue?vue&type=script&lang=ts"

import "./WorkspaceLayout.vue?vue&type=style&index=0&id=02e18c70&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__